import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function LondonOvergroundStation(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fill: "#F27C2D",
    fillRule: "evenodd",
    d: "M1.5 10a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0zM10 4.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "#1A4297",
    d: "M0 8h20v4H0z"
  }));
}

export { LondonOvergroundStation };
//# sourceMappingURL=LondonOvergroundStation.js.map